import { CellContext } from '@tanstack/react-table';
import { AvailabilityFieldDto } from '@/features/dashboard/tours/types/AvailabilityFieldDto.ts';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/Tooltip.tsx';
import { CellSecondary } from '@/components/table/_fieldDefinitions/_base/CellSecondary.tsx';
import { EmptyValue } from '@/components/ui/EmptyValue.tsx';

/**
 * Zajętość zawsze jako ułamek — samo „12” nie mówi, czy to dużo. Wyjazd bez
 * limitu dostaje `∞` w mianowniku, żeby kolumna miała jeden kształt.
 */
export const availabilityFieldRender = <T,>(info: CellContext<T, unknown>) => {
  const value = info.getValue() as AvailabilityFieldDto | null;
  if (!value) return <EmptyValue />;

  const { currentCount, limit } = value;

  if (limit === null) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="cursor-default">
            <span className="font-bold">{currentCount}</span>
            <CellSecondary> / ∞</CellSecondary>
          </span>
        </TooltipTrigger>
        <TooltipContent>Bez limitu miejsc</TooltipContent>
      </Tooltip>
    );
  }

  if (currentCount >= limit) {
    return (
      <span className="text-accent-700">
        <span className="font-bold">{currentCount}</span> / {limit}
      </span>
    );
  }

  return (
    <>
      <span className="font-bold">{currentCount}</span>
      <CellSecondary> / {limit}</CellSecondary>
    </>
  );
};
